// extracted by mini-css-extract-plugin
export var defaultWrapper = "_k7-3";
export var downloadButton = "_k7-4";
export var fileContainer = "_k7-9 _k7-7";
export var fileContainerBase = "_k7-7";
export var fileContainerBaseSm = "_k7-a _k7-7";
export var fileContainerFixedHeight = "_k7-8 _k7-7";
export var fileContainerFixedHeightSm = "_k7-c _k7-a _k7-7";
export var fileContainerSm = "_k7-b _k7-a _k7-7";
export var fileInfo = "_k7-5";
export var fileInfoWidthRestricted = "_k7-6";
export var fileType = "_k7-1";
export var fileTypeName = "_k7-2";
export var fileTypeSm = "_k7-d _k7-1";
export var image = "_k7-0";
export var link = "_k7-f";
export var overflowEllipsis = "_k7-e";